/**
 * Local mirror of the RCS provider message-type contract.
 *
 * Values must stay identical to the wire format used by `@trendbuild/trend-rcs-api`
 * (RCSMessageTypeEnum / RCSMessageContentRichCardTypeEnum). The package itself is
 * NOT browser-safe as of 1.1.0 (its base service requires Node's `https`), so the
 * frontend keeps this mirror instead of depending on the lib.
 */
export enum RCSMessageTypeEnum {
  TEXT = 'text',
  IMAGE = 'image',
  PDF = 'pdf',
  VIDEO = 'video',
  RICH_CARD = 'richCard',
  CAROUSEL = 'carousel',
}

export enum RCSMessageContentRichCardTypeEnum {
  OPEN_URL = 'openUrl',
  CALL = 'call',
  REPLY = 'reply',
}
